const isoMois = (annee, mois) => `${annee}-${String(mois).padStart(2, '0')}`;
const dernierJour = (annee, mois) => new Date(Date.UTC(annee, mois, 0)).getUTCDate();

export function creerContexteFinancier(source = {}) {
  const commercialAnalyse = String(source.commercialAnalyse ?? source.commercial ?? '').trim();
  const anneeNombre = Number(source.annee);
  const moisNombre = Number(source.mois);
  if (!Number.isInteger(anneeNombre) || !Number.isInteger(moisNombre) || moisNombre < 1 || moisNombre > 12) {
    throw new Error('CONTEXTE_FINANCIER_INVALIDE');
  }
  if (!commercialAnalyse) throw new Error('COMMERCIAL_ANALYSE_INDISPONIBLE');
  const prefixe = isoMois(anneeNombre, moisNombre);
  const fluxDebut = `${prefixe}-01`;
  const fluxFin = `${prefixe}-${String(dernierJour(anneeNombre, moisNombre)).padStart(2, '0')}`;
  const anneeExercice = moisNombre >= 4 ? anneeNombre : anneeNombre - 1;
  const exerciceDebut = `${anneeExercice}-04-01`;
  const cumulFin = fluxFin;
  const dateArrete = fluxFin;
  const mode = String(source.modePeriode || 'Mois');
  const contextKey = `${String(source.groupe || '').trim().toLocaleLowerCase('fr-FR')}|${commercialAnalyse.toLocaleLowerCase('fr-FR')}|${dateArrete}|${mode}`;
  const periodes = Object.freeze({
      libelle: new Date(`${fluxDebut}T12:00:00`).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase(),
      mois: Object.freeze({ debut: fluxDebut, fin: fluxFin }),
      cumul: Object.freeze({ debut: exerciceDebut, fin: cumulFin }),
      dateArrete,
      nonCloturee: fluxFin >= new Date().toISOString().slice(0, 10)
  });
  return Object.freeze({
    version: 1, contextKey, cle: contextKey,
    commercialAnalyse, commercialCommande: commercialAnalyse, commercialId: commercialAnalyse,
    annee: anneeNombre, mois: moisNombre, anneeExercice,
    modePeriode: mode, fluxDebut, fluxFin, exerciceDebut, cumulFin,
    exerciceFin: cumulFin, dateArrete, periodes
  });
}

export function creerGardeReponseContextuelle(cleInitiale = '') {
  let cleActive = cleInitiale;
  let sequence = 0;
  return {
    activer(cle) {
      cleActive = cle;
      sequence += 1;
      return { cle, sequence };
    },
    estActive(jeton) {
      return Boolean(jeton && jeton.cle === cleActive && jeton.sequence === sequence);
    },
    appliquer(jeton, traitement) {
      if (!this.estActive(jeton)) return false;
      traitement();
      return true;
    }
  };
}
